import styled from 'styled-components'

import Link from 'components/icons/Link'
import { Radio as AntdRadio } from 'antd'
export const Heading = styled.div`
  font-weight: 600;
  font-size: 1.1428571428571428em;
  line-height: 21px;
  color: #1b1f22;
`

export const Text = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  color: #3249d7;
  white-space: nowrap;
`
export const LocalLink = styled(Link)``
export const LinkWrap = styled.div`
  margin-top: 12px;
`

export const RadioGroup = styled(AntdRadio.Group)`
  display: flex;
  gap: 15px;
  margin-top: 8px;
  ${props => props?.spaceBetween && 'justify-content: space-between;'}
  `
